import { useEffect, useState } from "react";
import { useAuthContext } from "../../context/AuthContext";
import getFirmsInNetwork from "../../apis/getFirmsInNetwork";
import BlockHeader from "../Headers/BlockHeader";
import FirmLogo from "../Images/FirmLogo";
import { AlertInfo } from "../Alerts/Alert";
import ComponentLoader from "../Loader/ComponentLoader";

const FirmInNetwork = () => {
  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(false);

  useEffect(() => {
    if (user_slug !== undefined) {
      getFavoriteProfiles();
    }
  }, [user_slug]);

  const getFavoriteProfiles = () => {
    Promise.all([getFirmsInNetwork(user_slug)])
      .then(async ([data]) => {
        if (data?.data?.status === 0) {
          setIsLoading(false);
        } else {
          if (data?.data?.result) {
            setData(data?.data?.result);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const displayList = () => {
    return (
      <>
        <div className="table-responsive  table-wrapper scrollable">
          <table className="table table-bordered">
            <thead className="no-border">
              <tr className="border-top-0">
                <th>Firm</th>
                <th>Candidates</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index.toString()}>
                  <td>
                    <FirmLogo url={item.firm_logo} />
                  </td>
                  <td className="align-middle">
                    <span class="badge badge-primary">
                      {item.profile_count}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const displayContent = () => {
    if (!data) {
      return <AlertInfo message="Nothing to display here!" />;
    } else {
      return displayList();
    }
  };

  const checkIsLoading = () => {
    if (isLoading) {
      return <ComponentLoader />;
    } else {
      return displayContent();
    }
  };

  return (
    <div class="card">
      <div className="card-body">
        <BlockHeader
          title={"My Network (Firms)"}
          subText={"Firms and searchable profiles"}
        />

        {checkIsLoading()}
      </div>
    </div>
  );
};

export default FirmInNetwork;
